// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "5fa8fff406ebf7c1","396": "5356e8233d46dd46","460": "1e06a2bb4a9d732f","498": "fccdfe5fa3c6875b","917": "8c8d49b26867ac4d","985": "66705532dd6efa5a",}[chunkId] + ".chunk.js"
}